const Keys = {
  api_uri: process.env.REACT_APP_API_URL || 'http://192.168.29.101:5000/api',
  payuKey: process.env.REACT_APP_PAYU_KEY || '8XWxMU',
  payuSalt: process.env.REACT_APP_PAYU_SALT || 'wt6qKzet',
  payu_uri: process.env.REACT_APP_PAYU_UR || 'https://test.payu.in',
};

export default Keys;
